import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useUserStore } from '@/store/userStore';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated: isFirebaseAuthenticated, isLoading } = useAuth();
  const { userId, user } = useUserStore();
  const location = useLocation();

  // User is authenticated either via Firebase OR via bypass auth (uid in userStore)
  const isAuthenticated = isFirebaseAuthenticated || (!!userId && !!user);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 text-primary animate-spin" />
          <p className="text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Save the attempted URL for redirecting after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

